import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useTaskStagesList() {

    //User toast
    const toast = useToast()

    const refTaskStageListTable = ref(null)

    const tableColumns = [
        {key: 'stage', label:'STATUS', sortable: true},
        {key: 'description'},
        {key: 'complete_bit'},
        {key: 'demo', label:'LABEL'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalTaskStages = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refTaskStageListTable.value ? refTaskStageListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalTaskStages.value,
        }
    })

    const refetchData = () => {
        refTaskStageListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchTaskStages = (ctx, callback) => {
        store.dispatch('setting-taskstage/fetchTaskStages',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {taskstages, total} = response.data
            callback(taskstages)
            totalTaskStages.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching task stages list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchTaskStages,
        tableColumns,
        perPage,
        currentPage,
        totalTaskStages,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTaskStageListTable,
        ability,
        refetchData
    }

}